import PropTypes from 'prop-types';
import React from 'react';
import ImageNg from '@fec/frontend/elements/media/image-ng/ImageNg';
import './PersonBox.scss';

const PersonBox = ({ person }) => {
  const { name, position, image } = person;
  const imageObject = {
    provider: 'rokka',
    id: image,
    alt: name,
  };

  return (
    <div className="personbox" role="text">
      <div className="circle-image circle-image--profile-picture-small">
        <ImageNg image={imageObject} styleModifier="image-ng--no-bg" />
      </div>
      <div
        className="person-details"
        itemScope
        itemType="https://schema.org/Person">
        <p className="person-details__name" itemProp="name">
          {name}
        </p>
        {position && (
          <p className="person-details__function" itemProp="jobTitle">
            {position}
          </p>
        )}
      </div>
    </div>
  );
};

PersonBox.propTypes = {
  person: PropTypes.object.isRequired,
};

export default PersonBox;
